import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntPortalSlotComponent} from "./int-portal-slot.component";
import {IntPortalSlotTemplateDirective} from "./int-portal-slot-template.directive";
import {SatelliteService} from "../../services";
import {IntPortalSlotViewportContainerDirective} from "./int-portal-slot-viewport-container.directive";

@NgModule({
  imports: [CommonModule],
  declarations: [IntPortalSlotComponent, IntPortalSlotTemplateDirective, IntPortalSlotViewportContainerDirective],
  exports: [IntPortalSlotComponent, IntPortalSlotTemplateDirective],
  providers: [
    SatelliteService
  ]
})
export class IntPortalSlotModule {}
